import PageLayout from "../../layouts/PageLayout"
import WhatsAppChat from "../../components/WhatsAppChat"
import Header from "./components/Header"
import TrustStrip from "./components/TrustStrip"
import WhatsIncluded from "./components/WhatsIncluded"
import AvailableCars from "./components/AvailableCars"
import ContactSection from "../../components/ContactSection"
import FAQs from "./components/FAQs"

const Home = () => (
    <PageLayout hero={<Header />}>
        <TrustStrip />
        <WhatsIncluded />
        <AvailableCars />
        <ContactSection variant="dark" id="contact" />
        <FAQs />
        <WhatsAppChat />
    </PageLayout>
)

export default Home
